import {
	IAtomicCondition,
	ITaskCondition,
	ITaskConditions,
	VariableType
} from '../../../../types/flows';

const indexExp = /\w+.(\d).\w+.(\d)/g;

export const getFieldPathIndices = (s: string) => {
	const index = new RegExp(indexExp).exec(s);
	if (index && index.length > 2) {
		return {
			taskIndex: Number(index[1]),
			condIndex: Number(index[2])
		};
	}

	return {};
};

export const FORM_KEYS = {
	taskName: 'taskName',
	taskConditions: 'taskConditions'
};

export const ELSE_INTERACTION_ID = 'ELSE';

export const elseStepCondition = {
	interactionId: ELSE_INTERACTION_ID,
	name: ELSE_INTERACTION_ID,
	atomicConditions: []
};

export const newAtomicCondition = (): IAtomicCondition => ({
	target: {
		type: VariableType.context,
		value: ''
	},
	operator: '',
	predicate: {
		type: VariableType.inline,
		value: ''
	}
});

export const newCondition = (name?: string): ITaskCondition => ({
	interactionId: Math.random().toString(36).substring(2),
	name: name || '',
	logicalOr: false,
	atomicConditions: [newAtomicCondition()]
});

export const getElseLabel = (taskConditions?: ITaskConditions) => {
	const elseCondition = taskConditions?.find(
		(c) => c.interactionId === ELSE_INTERACTION_ID
	);

	return elseCondition?.name || ELSE_INTERACTION_ID;
};
